export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = "x-flag-exp"
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = "x-flag-internal"

export const flags = {
  FLAG_FEAT_ANNUAL_SURVEY: "membership-annual-survey-link",
  FLAG_FEAT_CAREER_PROFILE_DASHBOARD: "pga-career-profile-dashboard",
  FLAG_FEAT_EDUCATION_PGM_LEVEL_PURCHASE: "education-pgm-level-purchase",
  FLAG_FEAT_PTM_APPLICATIONS_REDIRECT: "account-ptm-applications-redirect",
  FLAG_FEAT_PENDING_AFFILIATE_BAND: "membership-pending-affiliate-band",
}
